<div
  class="invitation"
  [ngClass]="{ mobile: rwdService.isSmallDevice, 'with-check': invitedNumber }"
  *ngIf="!isSubmitting; else templateService.loader"
>
  <button
    class="header-action"
    mat-flat-button
    type="button"
    (click)="sendAppInvite()"
    [disabled]="inviteSent"
    [matTooltip]="inviteSent ? ('appInvite.sendTT' | loc) : ''"
  >
    <mat-icon color="primary">send</mat-icon>
    {{ 'appInvite.send' | loc }}
  </button>
  <mat-icon class="check" *ngIf="invitedNumber" [matTooltip]="'label.sent' | loc" matTooltipPosition="above">
    check_circle
  </mat-icon>
</div>
